import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom'

function App(props) {
  return (
    <Router>
      <div className="App">
        {props.children}
      </div>
    </Router>
  );
}

export default App;
